import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'download': return 'Download';
      case 'upload': return 'Upload';
      case 'update': return 'RefreshCw';
      case 'citation': return 'Quote';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'download': return 'text-[var(--color-info)]';
      case 'upload': return 'text-[var(--color-success)]';
      case 'update': return 'text-[var(--color-warning)]';
      case 'citation': return 'text-[var(--color-accent)]';
      default: return 'text-[var(--color-muted-foreground)]';
    }
  };

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 border border-[var(--color-border)]">
      <h3 className="text-lg font-semibold text-[var(--color-card-foreground)] mb-6 flex items-center gap-2">
        <Icon name="Activity" size={20} />
        Recent Activity
      </h3>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-4 pb-4 border-b border-[var(--color-border)] last:border-0 last:pb-0">
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-[var(--color-muted)]">
              <Image 
                src={activity?.userAvatar} 
                alt={activity?.userAvatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-1">
                <p className="text-sm text-[var(--color-card-foreground)]">
                  <span className="font-medium">{activity?.userName}</span>
                  {' '}
                  <span className="text-[var(--color-muted-foreground)]">{activity?.action}</span>
                  {' '}
                  <span className="font-medium">{activity?.dataset}</span>
                </p>
                <Icon 
                  name={getActivityIcon(activity?.type)} 
                  size={16} 
                  className={getActivityColor(activity?.type)}
                />
              </div>
              <p className="text-xs text-[var(--color-muted-foreground)]">{activity?.timestamp}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;